import { action } from 'typesafe-actions';
import { SellDeliveryMethodActionTypes as act } from './actionTypes';

export function selectDeliveryMethod(deliveryMethod) {
  return action(act.SELECT_DELIVERY_METHOD, { deliveryMethod });
}

export function palceholderReset() {
  return action(act.RESET_TRANSACTION);
}
